// src/Science/ScienceQuizPools.js

// 1️⃣ What is Science? pool
export const scienceQuizPools = {
    1: {
      // Grade 1
      // Chapter 1: What is Science?
      1: [
        {
          question: "What do scientists do?",
          correctAnswer: "They ask questions and look for answers",
          options: [
            "They just watch TV",
            "They ask questions and look for answers",
            "They never share ideas",
          ],
        },
        {
          question: "Which is something scientists study?",
          correctAnswer: "Animals, plants, space, and more",
          options: ["Only candies", "Animals, plants, space, and more", "Nothing at all"],
        },
        // NEW
        {
          question: "Scientists often use tools like magnifying glasses to?",
          correctAnswer: "Observe things more closely",
          options: [
            "Watch television better",
            "Observe things more closely",
            "Play video games",
          ],
        },
        {
          question: "Where can science be done?",
          correctAnswer: "Anywhere, like a lab or even at home",
          options: [
            "Only in big laboratories",
            "Anywhere, like a lab or even at home",
            "Only outdoors",
          ],
        },
        {
          question: "Why do scientists share their ideas?",
          correctAnswer: "To help others learn and make new discoveries",
          options: [
            "To keep secrets",
            "To help others learn and make new discoveries",
            "To stop other people from studying",
          ],
        },
        {
          question: "What is an experiment?",
          correctAnswer: "A test that helps answer a question",
          options: [
            "A fun magic trick",
            "A test that helps answer a question",
            "A type of computer",
          ],
        },
        {
          question: "When scientists make a guess they can test, it is called?",
          correctAnswer: "A hypothesis",
          options: ["A fact", "A hypothesis", "An argument"],
        },
        {
          question: "Why do scientists write down what they learn?",
          correctAnswer: "So they can remember and share it with others",
          options: [
            "Because they like to draw pictures",
            "So they can remember and share it with others",
            "They never write things down",
          ],
        },
        {
          question: "What do scientists use to measure how long something is?",
          correctAnswer: "A ruler or a measuring tape",
          options: [
            "A calendar",
            "A ruler or a measuring tape",
            "Their hand only",
          ],
        },
        {
          question: "How do scientists learn new things?",
          correctAnswer: "By asking questions, observing, and experimenting",
          options: [
            "By guessing and not checking",
            "By asking questions, observing, and experimenting",
            "By playing video games",
          ],
        },
      ],
      // Chapter 2: Living vs Non-Living
      2: [
        {
          question: "Which is a sign that something is living?",
          correctAnswer: "It grows or can have babies",
          options: [
            "It stays the same forever",
            "It grows or can have babies",
            "It never changes",
          ],
        },
        {
          question: "A dog is living because it?",
          correctAnswer: "Eats, grows, and can reproduce",
          options: [
            "Is made of plastic",
            "Eats, grows, and can reproduce",
            "Stays still forever",
          ],
        },
        // NEW
        {
          question: "Which of these is not living?",
          correctAnswer: "A rock",
          options: ["A rock", "A tree", "A bird"],
        },
        {
          question: "Which of these must all living things need?",
          correctAnswer: "Food and water",
          options: [
            "Television and toys",
            "Food and water",
            "A car to ride in",
          ],
        },
        {
          question: "How do we know plants are living things?",
          correctAnswer: "They grow from seeds and can make more plants",
          options: [
            "They never change",
            "They grow from seeds and can make more plants",
            "They are made of metal",
          ],
        },
        {
          question: "Which part of a living thing shows it can move on its own?",
          correctAnswer: "An animal walking to find food",
          options: [
            "A clock ticking",
            "A computer turning on",
            "An animal walking to find food",
          ],
        },
        {
          question: "Living things respond to their environment by?",
          correctAnswer: "Reacting to changes around them (like light or heat)",
          options: [
            "Staying the same forever",
            "Reacting to changes around them (like light or heat)",
            "Turning into rocks",
          ],
        },
        {
          question: "Which of the following is a living thing’s need?",
          correctAnswer: "Air to breathe",
          options: ["Plastic", "Air to breathe", "Television shows"],
        },
        {
          question: "Which of these is a characteristic of non-living things?",
          correctAnswer: "They do not eat or grow",
          options: [
            "They always need water",
            "They do not eat or grow",
            "They produce babies",
          ],
        },
        {
          question: "Why do living things move, eat, and grow?",
          correctAnswer: "Because they have life processes",
          options: [
            "Because they are broken machines",
            "Because they have life processes",
            "It’s just for fun",
          ],
        },
      ],
    },
    2: {
      // Grade 2
      // Chapter 1: Our Five Senses
      1: [
        {
          question: "Which sense helps you taste an apple?",
          correctAnswer: "Taste",
          options: ["Taste", "Sight", "Hearing"],
        },
        {
          question: "What do you use your eyes for?",
          correctAnswer: "To see",
          options: ["To smell", "To see", "To touch"],
        },
        {
          question: "Which part of your body helps you feel if something is hot or cold?",
          correctAnswer: "Skin",
          options: ["Eyes", "Skin", "Teeth"],
        },
        {
          question: "Which sense helps you listen to music?",
          correctAnswer: "Hearing",
          options: ["Smell", "Taste", "Hearing"],
        },
        {
          question: "Which sense lets you smell a flower?",
          correctAnswer: "Smell",
          options: ["Hearing", "Smell", "Sight"],
        },
        // NEW
        {
          question: "Which sense warns you when food tastes too spicy?",
          correctAnswer: "Taste",
          options: ["Hearing", "Touch", "Taste"],
        },
        {
          question: "What sense helps you know if something is soft or rough?",
          correctAnswer: "Touch",
          options: ["Touch", "Smell", "Hearing"],
        },
        {
          question: "Why is it important to protect your ears from loud noises?",
          correctAnswer: "To keep your hearing sense safe",
          options: [
            "To keep your hearing sense safe",
            "Because you might not see again",
            "So your nose doesn't hurt",
          ],
        },
        {
          question: "When you enjoy the scent of a fresh pie, which sense are you using?",
          correctAnswer: "Smell",
          options: ["Touch", "Smell", "Sight"],
        },
        {
          question: "When you see a rainbow, you are using which sense?",
          correctAnswer: "Sight",
          options: ["Taste", "Sight", "Hearing"],
        },
      ],
      // Chapter 2: Habitats and Homes
      2: [
        {
          question: "What is a habitat?",
          correctAnswer: "A place where animals and plants live",
          options: [
            "A type of animal",
            "A place where animals and plants live",
            "A kind of weather",
          ],
        },
        {
          question: "Which animal might live in a desert?",
          correctAnswer: "Camel",
          options: ["Camel", "Penguin", "Frog"],
        },
        {
          question: "Why do animals need habitats?",
          correctAnswer: "For food, water, and shelter",
          options: [
            "To play games",
            "For food, water, and shelter",
            "To watch TV",
          ],
        },
        {
          question: "Who helps protect animal habitats?",
          correctAnswer: "Scientists",
          options: ["Chefs", "Artists", "Scientists"],
        },
        {
          question: "What do lily pads need to live?",
          correctAnswer: "A pond habitat",
          options: ["A desert", "A pond habitat", "A mountain"],
        },
        // NEW
        {
          question: "Which habitat has very cold temperatures and ice most of the year?",
          correctAnswer: "Polar region",
          options: ["Polar region", "Rainforest", "Desert"],
        },
        {
          question: "In a forest habitat, you might find?",
          correctAnswer: "Trees, deer, and other woodland animals",
          options: [
            "Only rocks and sand",
            "Cars and buses",
            "Trees, deer, and other woodland animals",
          ],
        },
        {
          question: "Which habitat is home to fish, coral, and other sea life?",
          correctAnswer: "Ocean",
          options: ["Desert", "Ocean", "City"],
        },
        {
          question: "Why do some animals migrate?",
          correctAnswer: "They move to find better food or weather",
          options: [
            "They want to learn new languages",
            "They move to find better food or weather",
            "They like traveling for fun",
          ],
        },
        {
          question: "What is one way humans can help protect habitats?",
          correctAnswer: "By reducing pollution and cleaning up trash",
          options: [
            "By throwing trash anywhere",
            "By chasing animals away",
            "By reducing pollution and cleaning up trash",
          ],
        },
      ],
    },
    3: {
      // Grade 3
      // Chapter 1: Plant Life Cycles
      1: [
        {
          question: "What do all plants start as?",
          correctAnswer: "Seeds",
          options: ["Leaves", "Roots", "Seeds"],
        },
        {
          question: "What helps plants grow?",
          correctAnswer: "Water, soil, and sunlight",
          options: [
            "Candy and soda",
            "Water, soil, and sunlight",
            "Toys and games",
          ],
        },
        {
          question: "Pollination helps plants make?",
          correctAnswer: "Seeds",
          options: ["Bark", "Seeds", "Wings"],
        },
        {
          question: "Who helps pollinate flowers?",
          correctAnswer: "Bees",
          options: ["Cats", "Bees", "Fish"],
        },
        {
          question: "Why are plant life cycles important?",
          correctAnswer: "They give us food, oxygen, and flowers",
          options: [
            "They make things dirty",
            "They give us food, oxygen, and flowers",
            "They never change",
          ],
        },
        // NEW
        {
          question: "Which part of the plant holds it in the ground and takes in water?",
          correctAnswer: "Roots",
          options: ["Flowers", "Roots", "Stems"],
        },
        {
          question: "What is the function of a plant’s stem?",
          correctAnswer: "To support the plant and carry water",
          options: [
            "To produce seeds only",
            "To attract bees only",
            "To support the plant and carry water",
          ],
        },
        {
          question: "Which part of the plant makes food using sunlight?",
          correctAnswer: "Leaves",
          options: ["Roots", "Leaves", "Seeds"],
        },
        {
          question: "Which process describes a seed starting to grow?",
          correctAnswer: "Germination",
          options: ["Hibernation", "Germination", "Pollination"],
        },
        {
          question: "How do animals help some plants reproduce?",
          correctAnswer: "By carrying pollen or seeds to new places",
          options: [
            "By hiding seeds in dark rooms",
            "By eating all the flowers",
            "By carrying pollen or seeds to new places",
          ],
        },
      ],
      // Chapter 2: Forces and Movement
      2: [
        {
          question: "What is a force?",
          correctAnswer: "A push or pull",
          options: ["A type of animal", "A push or pull", "A food"],
        },
        {
          question: "What force pulls things to the ground?",
          correctAnswer: "Gravity",
          options: ["Friction", "Gravity", "Wind"],
        },
        {
          question: "Friction is a force that?",
          correctAnswer: "Slows things down",
          options: [
            "Makes things disappear",
            "Slows things down",
            "Makes things fly",
          ],
        },
        {
          question: "Which is an example of a force?",
          correctAnswer: "Kicking a ball",
          options: ["Sleeping", "Kicking a ball", "Reading a book"],
        },
        {
          question: "Why do we study forces?",
          correctAnswer: "To understand how things move",
          options: [
            "To watch more TV",
            "To understand how things move",
            "To eat more food",
          ],
        },
        // NEW
        {
          question: "What happens when you push an object harder?",
          correctAnswer: "It usually moves faster or farther",
          options: [
            "It stays in the same place",
            "It floats in the air",
            "It usually moves faster or farther",
          ],
        },
        {
          question: "Which surface would likely have more friction?",
          correctAnswer: "Rough concrete",
          options: ["Smooth ice", "Rough concrete", "Wet glass"],
        },
        {
          question: "Which of these reduces friction?",
          correctAnswer: "Using oil or lubricant",
          options: [
            "Adding more weight",
            "Using oil or lubricant",
            "Making surfaces rougher",
          ],
        },
        {
          question: "If you drop two objects, which force acts on them?",
          correctAnswer: "Gravity",
          options: ["Friction", "Air pressure", "Gravity"],
        },
        {
          question: "When you pull a wagon with a rope, you are applying?",
          correctAnswer: "A pulling force",
          options: [
            "A blocking force",
            "A frictional force",
            "A pulling force",
          ],
        },
      ],
    },
    4: {
      // Grade 4
      // Chapter 1: The Water Cycle
1: [
  {
    question: "What is the water cycle?",
    correctAnswer: "The way water moves around Earth",
    options: [
      "A type of bicycle",
      "The way water moves around Earth",
      "A kind of rainstorm",
    ],
  },
  {
    question: "What turns water into vapor in the water cycle?",
    correctAnswer: "The sun’s heat",
    options: [
      "The wind",
      "The sun’s heat",
      "Frogs",
    ],
  },
  {
    question: "What is precipitation?",
    correctAnswer: "Rain, snow, or hail falling from clouds",
    options: [
      "The sun shining",
      "Clouds disappearing",
      "Rain, snow, or hail falling from clouds",
    ],
  },
  {
    question: "What do we call it when water gathers in rivers and lakes?",
    correctAnswer: "Collection",
    options: [
      "Evaporation",
      "Collection",
      "Condensation",
    ],
  },
  {
    question: "What is condensation?",
    correctAnswer: "Water vapor cooling to form clouds",
    options: [
      "The sun heating water",
      "Water vapor cooling to form clouds",
      "Water flowing in rivers",
    ],
  },
],
      // Chapter 2: Ecosystems
      // Chapter 2: What is Energy?
2: [
  {
    question: "What is energy?",
    correctAnswer: "What makes things move and work",
    options: [
      "A type of animal",
      "A special plant",
      "What makes things move and work",
    ],
  },
  {
    question: "Which of these is a form of energy?",
    correctAnswer: "Light",
    options: [
      "Light",
      "Banana",
      "Cloud",
    ],
  },
  {
    question: "Where does most energy on Earth come from?",
    correctAnswer: "The sun",
    options: [
      "The moon",
      "The sun",
      "Oceans",
    ],
  },
  {
    question: "Which uses energy?",
    correctAnswer: "All of these (playing, cooking, lights)",
    options: [
      "Playing soccer",
      "Cooking food",
      "All of these (playing, cooking, lights)",
    ],
  },
  {
    question: "How can you help save energy?",
    correctAnswer: "Turn off lights when not needed",
    options: [
      "Leave the TV on all night",
      "Turn off lights when not needed",
      "Open the fridge all day",
    ],
  },
],
    },
    5: {
      // Grade 5
      // Chapter 1: The Human Body
      1: [
        {
          question: "What does the skeleton do for our body?",
          correctAnswer: "Gives us shape and support",
          options: [
            "Makes us grow hair",
            "Gives us shape and support",
            "Helps us see in the dark"
          ],
        },
        {
          question: "Which organ pumps blood throughout the body?",
          correctAnswer: "Heart",
          options: ["Lungs", "Heart", "Stomach"]
        },
        {
          question: "Muscles work together with bones to help us?",
          correctAnswer: "Move",
          options: ["Grow leaves", "See colors", "Move"]
        },
        {
          question: "Where does digestion begin?",
          correctAnswer: "In the mouth",
          options: [
            "In the stomach",
            "In the mouth",
            "In the lungs"
          ],
        },
        {
          question: "What carries oxygen in our blood?",
          correctAnswer: "Red blood cells",
          options: [
            "White blood cells",
            "Red blood cells",
            "Platelets"
          ],
        },
      ],
      
      // Chapter 2: Simple Machine
      2: [
        {
          question: "Which of these is a simple machine?",
          correctAnswer: "Lever",
          options: [
            "Car",
            "Lever",
            "Battery"
          ],
        },
        {
          question: "A ramp is also called a(n)?",
          correctAnswer: "Inclined plane",
          options: [
            "Pulley",
            "Screw",
            "Inclined plane"
          ],
        },
        {
          question: "What does a pulley help us do?",
          correctAnswer: "Lift things easily with a rope and wheel",
          options: [
            "See tiny objects",
            "Lift things easily with a rope and wheel",
            "Store food"
          ],
        },
        {
          question: "A wedge helps us?",
          correctAnswer: "Split things apart",
          options: [
            "Hold things together",
            "Split things apart",
            "Measure weight"
          ],
        },
        {
          question: "Where might you find a screw?",
          correctAnswer: "Holding wood or metal together",
          options: [
            "On a tree branch",
            "Holding wood or metal together",
            "In a glass of water"
          ],
        },
      ],
      
    },
    6: {
      // Grade 6
      // Chapter 1: BioDiversity
      1: [
        {
          question: "What is biodiversity?",
          correctAnswer: "The variety of living things in an area",
          options: [
            "The study of rocks",
            "The variety of living things in an area",
            "The number of planets in the Solar System"
          ],
        },
        {
          question: "Why is biodiversity important?",
          correctAnswer: "It helps keep ecosystems healthy",
          options: [
            "It makes weather colder",
            "It helps keep ecosystems healthy",
            "It makes water disappear"
          ],
        },
        {
          question: "Which of these has the most biodiversity?",
          correctAnswer: "A rainforest",
          options: [
            "A rainforest",
            "A desert with only sand",
            "A room with one plant"
          ],
        },
        {
          question: "What can reduce biodiversity?",
          correctAnswer: "Pollution and destroying habitats",
          options: [
            "Planting more trees",
            "Pollution and destroying habitats",
            "Saving endangered animals"
          ],
        },
        {
          question: "How can we protect biodiversity?",
          correctAnswer: "Protecting animal habitats",
          options: [
            "Cutting down all trees",
            "Protecting animal habitats",
            "Making more pollution"
          ],
        }
      ],
      
      // Chapter 2: Electricity
      2: [
        {
          question: "What is electricity?",
          correctAnswer: "A type of energy that can flow through wires",
          options: [
            "A kind of plant",
            "A type of energy that can flow through wires",
            "A type of animal"
          ],
        },
        {
          question: "What do you need to make a simple circuit?",
          correctAnswer: "A battery, wire, and a bulb",
          options: [
            "A chair, table, and book",
            "A battery, wire, and a bulb",
            "A ball and a bat"
          ],
        },
        {
          question: "What is a conductor?",
          correctAnswer: "A material that lets electricity flow through it",
          options: [
            "A type of tree",
            "A material that lets electricity flow through it",
            "A song"
          ],
        },
        {
          question: "Which is a good conductor?",
          correctAnswer: "Metal",
          options: [
            "Wood",
            "Plastic",
            "Metal"
          ],
        },
        {
          question: "How can you stay safe with electricity?",
          correctAnswer: "Don't touch outlets or wires",
          options: [
            "Touch every wire",
            "Don't touch outlets or wires",
            "Play with water near plugs"
          ],
        }
      ],
      
    },
    7: {
      // Grade 7
      // Chapter 1: Ecosystem and Interactions
      1: [
        {
          question: "What is an ecosystem?",
          correctAnswer: "A community of living and non-living things interacting together",
          options: [
            "A place where only plants live",
            "A group of people at school",
            "A community of living and non-living things interacting together"
          ],
        },
        {
          question: "Who are the producers in an ecosystem?",
          correctAnswer: "Plants that make their own food",
          options: [
            "Animals that eat meat",
            "Plants that make their own food",
            "Bacteria that break down waste"
          ],
        },
        {
          question: "What do consumers do in an ecosystem?",
          correctAnswer: "Eat plants or other animals",
          options: [
            "Make their own food",
            "Eat rocks",
            "Eat plants or other animals"
          ],
        },
        {
          question: "Decomposers are important because they?",
          correctAnswer: "Break down dead things and recycle nutrients",
          options: [
            "Eat only living plants",
            "Make the weather colder",
            "Break down dead things and recycle nutrients"
          ],
        },
        {
          question: "A food chain shows?",
          correctAnswer: "Who eats whom in an ecosystem",
          options: [
            "How plants grow",
            "Who eats whom in an ecosystem",
            "How weather changes"
          ],
        },
        {
          question: "What is a food web?",
          correctAnswer: "A network of connected food chains",
          options: [
            "A spider's home",
            "A network of connected food chains",
            "A group of trees"
          ],
        },
        {
          question: "What can cause changes in an ecosystem?",
          correctAnswer: "Weather, animals, and humans",
          options: [
            "Only sunshine",
            "Weather, animals, and humans",
            "Only plants"
          ],
        },
        {
          question: "Why should we keep ecosystems healthy?",
          correctAnswer: "They support life on Earth",
          options: [
            "To grow more rocks",
            "They support life on Earth",
            "So animals never sleep"
          ],
        },
        {
          question: "What is a decomposer example?",
          correctAnswer: "Mushroom",
          options: [
            "Wolf",
            "Mushroom",
            "Tree"
          ],
        },
        {
          question: "How can humans help ecosystems?",
          correctAnswer: "Protect habitats and reduce pollution",
          options: [
            "Cut down all trees",
            "Protect habitats and reduce pollution",
            "Remove all insects"
          ],
        },
      ],
      // Chapter 2: Heat and Particle Theory
      2: [
        {
          question: "What is heat?",
          correctAnswer: "Energy that makes things warmer",
          options: [
            "A kind of food",
            "Energy that makes things warmer",
            "A type of plant"
          ],
        },
        {
          question: "Which is an example of conduction?",
          correctAnswer: "Touching a hot pan handle",
          options: [
            "The Sun shining on Earth",
            "Touching a hot pan handle",
            "Soup moving in a pot"
          ],
        },
        {
          question: "How does heat move in liquids and gases?",
          correctAnswer: "By convection",
          options: [
            "By conduction",
            "By convection",
            "By freezing"
          ],
        },
        {
          question: "What is radiation?",
          correctAnswer: "Heat transfer through empty space",
          options: [
            "Heat transfer only through water",
            "Heat transfer through empty space",
            "Making a food web"
          ],
        },
        {
          question: "What happens to particles when something gets hotter?",
          correctAnswer: "They move faster",
          options: [
            "They stop moving",
            "They move faster",
            "They get bigger"
          ],
        },
        {
          question: "What is an example of convection?",
          correctAnswer: "Soup warming up as it moves in the pot",
          options: [
            "Touching a cold spoon",
            "Soup warming up as it moves in the pot",
            "Eating ice cream"
          ],
        },
        {
          question: "Why does sugar dissolve faster in hot water?",
          correctAnswer: "Particles move faster in hot water",
          options: [
            "Hot water is heavier",
            "Particles move faster in hot water",
            "Sugar is afraid of cold"
          ],
        },
        {
          question: "How does the Sun heat the Earth?",
          correctAnswer: "By radiation",
          options: [
            "By conduction",
            "By convection",
            "By radiation"
          ],
        },
        {
          question: "What can help homes use heat more efficiently?",
          correctAnswer: "Good insulation and design",
          options: [
            "Leave windows open",
            "Good insulation and design",
            "Paint the roof"
          ],
        },
        {
          question: "What are all things made of?",
          correctAnswer: "Tiny particles (atoms and molecules)",
          options: [
            "Just air",
            "Tiny particles (atoms and molecules)",
            "Only plants"
          ],
        },
      ]
      ,
    },
    8: {
      // Grade 8
      // Chapter 1: What are the cells
      1: [
  {
    question: "What are cells?",
    correctAnswer: "The building blocks of life",
    options: [
      "A type of light",
      "A food group",
      "The building blocks of life"
    ]
  },
  {
    question: "Animal cells and plant cells both have?",
    correctAnswer: "A nucleus",
    options: [
      "A cell wall only",
      "A nucleus",
      "Chlorophyll only"
    ]
  },
  {
    question: "Which structure is found only in plant cells?",
    correctAnswer: "Cell wall",
    options: [
      "Cell wall",
      "Mitochondria",
      "Nucleus"
    ]
  },
  {
    question: "What is the job of the digestive system?",
    correctAnswer: "Breaks down food for energy",
    options: [
      "Makes sunlight",
      "Breaks down food for energy",
      "Carries messages in the body"
    ]
  },
  {
    question: "The respiratory system helps us?",
    correctAnswer: "Breathe",
    options: [
      "Digest food",
      "Breathe",
      "Grow plants"
    ]
  },
  {
    question: "Which system sends messages around the body?",
    correctAnswer: "Nervous system",
    options: [
      "Digestive system",
      "Nervous system",
      "Respiratory system"
    ]
  },
  {
    question: "What do cells join together to make?",
    correctAnswer: "Tissues",
    options: [
      "Rocks",
      "Tissues",
      "Food"
    ]
  },
  {
    question: "Your skin is made of?",
    correctAnswer: "Millions of skin cells",
    options: [
      "Only one big cell",
      "Millions of skin cells",
      "Plants and animals"
    ]
  },
  {
    question: "Why is it important to study cells?",
    correctAnswer: "They help us understand health and disease",
    options: [
      "They are only in plants",
      "They help us understand health and disease",
      "They are not important"
    ]
  },
  {
    question: "Which tool do scientists use to see cells?",
    correctAnswer: "Microscope",
    options: [
      "Telescope",
      "Microscope",
      "Ruler"
    ]
  }
],
      // Chapter 2: Light and Optics
      2: [
        {
          question: "What is light?",
          correctAnswer: "A form of energy that helps us see",
          options: [
            "A type of cell",
            "A form of energy that helps us see",
            "A kind of food"
          ]
        },
        {
          question: "The Sun is our biggest source of?",
          correctAnswer: "Light",
          options: [
            "Food",
            "Light",
            "Plastic"
          ]
        },
        {
          question: "Light travels in?",
          correctAnswer: "Straight lines",
          options: [
            "Circles",
            "Straight lines",
            "Squares"
          ]
        },
        {
          question: "What happens when light hits a mirror?",
          correctAnswer: "It bounces (reflects)",
          options: [
            "It disappears",
            "It bounces (reflects)",
            "It becomes a cell"
          ]
        },
        {
          question: "What is optics?",
          correctAnswer: "The study of how light works",
          options: [
            "The study of food",
            "The study of how light works",
            "The study of cells"
          ]
        },
        {
          question: "Eyeglasses, cameras, and telescopes use?",
          correctAnswer: "Optics",
          options: [
            "Electricity only",
            "Optics",
            "Cells"
          ]
        },
        {
          question: "A rainbow is created by light being?",
          correctAnswer: "Bent and split into colors",
          options: [
            "Frozen in water",
            "Bent and split into colors",
            "Cooked by the sun"
          ]
        },
        {
          question: "Which part of the spectrum can humans NOT see?",
          correctAnswer: "Ultraviolet",
          options: [
            "Blue",
            "Red",
            "Ultraviolet"
          ]
        },
        {
          question: "What tool might help you see tiny details with light?",
          correctAnswer: "A microscope",
          options: [
            "A hammer",
            "A microscope",
            "A frying pan"
          ]
        },
        {
          question: "Why is studying light important?",
          correctAnswer: "It helps us invent new technology like lasers and solar panels",
          options: [
            "It is not important",
            "It helps us invent new technology like lasers and solar panels",
            "Only plants use light"
          ]
        }
      ],
      
    },
    9: {
      // Grade 9
      // Chapter 1: Reproduction and Genetics
      1: [
        {
          question: "What is reproduction?",
          correctAnswer: "How living things make more of themselves",
          options: [
            "How living things get food",
            "How living things make more of themselves",
            "How living things move"
          ]
        },
        {
          question: "Which is a way that plants reproduce?",
          correctAnswer: "By seeds, spores, or cuttings",
          options: [
            "By laying eggs only",
            "By seeds, spores, or cuttings",
            "By eating other plants"
          ]
        },
        {
          question: "Genetics is the study of?",
          correctAnswer: "How traits are passed from parents to offspring",
          options: [
            "The weather",
            "How traits are passed from parents to offspring",
            "Cooking food"
          ]
        },
        {
          question: "DNA is like a ______ for your body.",
          correctAnswer: "Code or instruction manual",
          options: [
            "Sandwich",
            "Code or instruction manual",
            "Tree"
          ]
        },
        {
          question: "Why is variation important for living things?",
          correctAnswer: "It helps species survive changes",
          options: [
            "It makes everyone the same",
            "It helps species survive changes",
            "It causes extinction"
          ]
        },
        {
          question: "Which of the following is an inherited trait?",
          correctAnswer: "Eye color",
          options: [
            "Favorite food",
            "Eye color",
            "Clothes you wear"
          ]
        },
        {
          question: "A gene is best described as:",
          correctAnswer: "A section of DNA that controls a trait",
          options: [
            "A type of cell",
            "A section of DNA that controls a trait",
            "A kind of plant"
          ]
        },
        {
          question: "Which term describes differences between individuals in a species?",
          correctAnswer: "Variation",
          options: [
            "Similarity",
            "Variation",
            "Conservation"
          ]
        },
        {
          question: "What is a possible risk of modern genetic engineering?",
          correctAnswer: "Ethical issues about how genes are used",
          options: [
            "It never works",
            "It can only be used on animals",
            "Ethical issues about how genes are used"
          ]
        },
        {
          question: "Why do scientists study genetics?",
          correctAnswer: "To understand health, medicine, and the future of food",
          options: [
            "To make new kinds of weather",
            "To understand health, medicine, and the future of food",
            "To build houses"
          ]
        }
      ],
      
      // Chapter 2: Chemistry
      2: [
        {
          question: "What is chemistry?",
          correctAnswer: "The science of what things are made of and how they change",
          options: [
            "The study of plants only",
            "The science of what things are made of and how they change",
            "How animals eat"
          ]
        },
        {
          question: "What are atoms?",
          correctAnswer: "Tiny building blocks of everything",
          options: [
            "Big blocks of ice",
            "Tiny building blocks of everything",
            "A kind of food"
          ]
        },
        {
          question: "Which state of matter keeps its shape?",
          correctAnswer: "Solid",
          options: [
            "Solid",
            "Liquid",
            "Gas"
          ]
        },
        {
          question: "A chemical change is when?",
          correctAnswer: "Something new is formed",
          options: [
            "Nothing changes",
            "Something new is formed",
            "Only water is added"
          ]
        },
        {
          question: "Which is an example of a chemical change?",
          correctAnswer: "Baking a cake",
          options: [
            "Tearing paper",
            "Baking a cake",
            "Freezing water"
          ]
        },
        {
          question: "Mixing vinegar and baking soda shows?",
          correctAnswer: "A chemical reaction with bubbles (gas)",
          options: [
            "Only a physical change",
            "A chemical reaction with bubbles (gas)",
            "A solid forming"
          ]
        },
        {
          question: "Why is chemistry important in daily life?",
          correctAnswer: "It helps us cook, clean, and make medicines",
          options: [
            "It is never used",
            "It helps us cook, clean, and make medicines",
            "Only plants use chemistry"
          ]
        },
        {
          question: "What are the three main states of matter?",
          correctAnswer: "Solid, liquid, gas",
          options: [
            "Rock, water, air",
            "Solid, liquid, gas",
            "Food, plants, energy"
          ]
        },
        {
          question: "Melting ice into water is an example of?",
          correctAnswer: "A physical change",
          options: [
            "A chemical change",
            "A physical change",
            "A weather event"
          ]
        },
        {
          question: "Who uses chemistry to make new medicines and green energy?",
          correctAnswer: "Scientists",
          options: [
            "Only chefs",
            "Only teachers",
            "Scientists"
          ]
        }
      ],
      
    },
    10: {
      // Grade 10
      // Chapter 1: Sustainability
      1: [
        {
          question: "What does 'sustainability' mean?",
          correctAnswer: "Meeting our needs without harming the planet for future generations",
          options: [
            "Using as many resources as possible",
            "Meeting our needs without harming the planet for future generations",
            "Cutting down all forests"
          ]
        },
        {
          question: "Which of the following is a sign of climate change?",
          correctAnswer: "Melting ice and rising sea levels",
          options: [
            "More computer use",
            "Melting ice and rising sea levels",
            "Fewer plants growing"
          ]
        },
        {
          question: "What causes most of the planet's recent warming?",
          correctAnswer: "Greenhouse gases from burning fossil fuels",
          options: [
            "Sun moving closer to Earth",
            "Greenhouse gases from burning fossil fuels",
            "Too many plants"
          ]
        },
        {
          question: "Which is a clean energy source?",
          correctAnswer: "Solar power",
          options: [
            "Burning coal",
            "Solar power",
            "Oil drilling"
          ]
        },
        {
          question: "Why should we recycle, reduce, and reuse?",
          correctAnswer: "To protect resources for the future",
          options: [
            "Because it's more expensive",
            "To protect resources for the future",
            "To create more waste"
          ]
        },
        {
          question: "What is an impact of climate change?",
          correctAnswer: "More floods, droughts, and wildfires",
          options: [
            "Colder summers only",
            "More floods, droughts, and wildfires",
            "Shorter winters only"
          ]
        },
        {
          question: "How can forests help fight climate change?",
          correctAnswer: "They absorb carbon dioxide",
          options: [
            "They create more pollution",
            "They absorb carbon dioxide",
            "They cause more fires"
          ]
        },
        {
          question: "What is one way YOU can help sustainability?",
          correctAnswer: "Use less electricity and recycle",
          options: [
            "Leave the lights on all night",
            "Use less electricity and recycle",
            "Drive everywhere, even short distances"
          ]
        },
        {
          question: "Which technology can help reduce climate change?",
          correctAnswer: "Electric cars",
          options: [
            "Gasoline-powered cars only",
            "Electric cars",
            "More landfills"
          ]
        },
        {
          question: "Why do we need to balance people, planet, and prosperity?",
          correctAnswer: "To ensure a healthy future for everyone",
          options: [
            "So we can use up all resources quickly",
            "To ensure a healthy future for everyone",
            "To ignore environmental problems"
          ]
        }
      ],
      
      // Chapter 2: Chemical Reaction
      2: [
        {
          question: "What is a chemical reaction?",
          correctAnswer: "When substances mix and make something new",
          options: [
            "Mixing without change",
            "When substances mix and make something new",
            "Breaking something in half"
          ]
        },
        {
          question: "Which is an example of a chemical reaction?",
          correctAnswer: "Baking a cake",
          options: [
            "Cutting paper",
            "Baking a cake",
            "Dissolving sugar in water"
          ]
        },
        {
          question: "What is combustion?",
          correctAnswer: "Burning fuel to release energy",
          options: [
            "Melting ice",
            "Burning fuel to release energy",
            "Freezing water"
          ]
        },
        {
          question: "Photosynthesis is a chemical reaction in which?",
          correctAnswer: "Plants make food using sunlight",
          options: [
            "Plants sleep",
            "Plants make food using sunlight",
            "Plants lose all their leaves"
          ]
        },
        {
          question: "What is a common sign of a chemical reaction?",
          correctAnswer: "Color change, heat, bubbles, or new smell",
          options: [
            "No change at all",
            "Color change, heat, bubbles, or new smell",
            "Just getting colder"
          ]
        },
        {
          question: "What is rusting?",
          correctAnswer: "Iron reacts with oxygen to form rust",
          options: [
            "Water boiling",
            "Iron reacts with oxygen to form rust",
            "Sand blowing in the wind"
          ]
        },
        {
          question: "Why are chemical reactions important in technology?",
          correctAnswer: "They power batteries, fuel cells, and even computers",
          options: [
            "They don’t matter in technology",
            "They power batteries, fuel cells, and even computers",
            "They slow down machines"
          ]
        },
        {
          question: "How can you observe a chemical reaction in the kitchen?",
          correctAnswer: "Mixing baking soda and vinegar to see bubbles",
          options: [
            "Freezing juice",
            "Mixing baking soda and vinegar to see bubbles",
            "Pouring water in a cup"
          ]
        },
        {
          question: "Which reaction is essential for life and technology?",
          correctAnswer: "Chemical reactions",
          options: [
            "Physical changes only",
            "Chemical reactions",
            "Weather changes"
          ]
        },
        {
          question: "Why study chemical reactions?",
          correctAnswer: "To solve big challenges like energy, health, and sustainability",
          options: [
            "Just for fun",
            "To solve big challenges like energy, health, and sustainability",
            "To make everything slower"
          ]
        }
      ],
      
    },
  };
  
  
  

  // Utility function for shuffling (if not already present)
export function shuffleArray(arr) {
    const cloned = [...arr];
    for (let i = cloned.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cloned[i], cloned[j]] = [cloned[j], cloned[i]];
    }
    return cloned;
  }
  
  // --- Quick Quiz generator (randomized subset from sciencePool) ---
  export function generateScienceQuizQuestions(grade = 1, chapter = 1, count = 5) {
    const pool = scienceQuizPools?.[grade]?.[chapter];
    if (!pool || pool.length === 0) return [];
    return shuffleArray(pool).slice(0, count);
  }
  
  
  
  // --- Final Quiz generator (randomized subset from both pools) ---
  export function generateScienceFinalQuestions(grade = 1, count = 10) {
    const gradePools = scienceQuizPools?.[grade];
    if (!gradePools) return [];
    const allQuestions = Object.values(gradePools).flat();
    return shuffleArray(allQuestions).slice(0, count);
  }
  
  // Add more quiz pools here for new topics or grades as needed.
  // Example:
  // export const grade2EarthSciencePool = [ ... ];
  